import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialLeadFilterData, initialProposalFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import LeadsFilterData from "./LeadsFilterData";

const LeadsFilter = ({ filterData, onSetFilterData, onCallApiAgain, from }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = from === "lead" ? countNonMatchingEntries(filterData, initialLeadFilterData) : countNonMatchingEntries(filterData, initialProposalFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const leadSaveSearchFilterData = {
    bds: filterData?.bds,
    broker: filterData?.broker,
    lead_source: filterData?.lead_source,
    created_at: filterData?.created_at,
    contact: filterData?.contact,
    lead_type: filterData?.lead_type === "" ? "" : filterData?.lead_type === "acquisition" ? 1 : 0,
    link_id: filterData?.link_id,
    property: filterData?.property,
    buyer_id: filterData?.buyer_id,
    last_contact: filterData?.last_contact ?? "date",
    lastContactSentDate: filterData?.lastContactSentDate ?? "",
    lastContactSentSdate: filterData?.lastContactSentSdate ?? "",
    lastContactSentEdate: filterData?.lastContactSentEdate ?? "",
    within_last_day: filterData?.within_last_day,
    longer_than_day: filterData?.longer_than_day,
    date_category: filterData?.date_category ?? "days",
  };

  const proposalSaveSearchFilterData = {
    bds: filterData?.bds,
    broker: filterData?.broker,
    created_at: filterData?.created_at,
    created_start_date: filterData?.created_start_date ?? "",
    created_end_date: filterData?.created_end_date ?? "",
    contact: filterData?.contact,
    lead_type: filterData?.lead_type === "" ? "" : filterData?.lead_type === "acquisition" ? 1 : 0,
    link_id: filterData?.link_id,
    status: filterData?.status === "" ? "" : filterData?.status === "followup" ? 0 : filterData?.status === "won" ? 1 : 2,
    property: filterData?.property,
    buyer_id: filterData?.buyer_id,

  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      bds: value?.bds ?? "",
      broker: value?.broker ?? "",
      created_at: value?.created_at ?? "",
      contact: value?.contact?.id === null ? { id: "", name: "" } : value?.contact,
      lead_type: value?.lead_type === null || value?.lead_type === "" ? "" : value?.lead_type === 1 ? "acquisition" : "disposition",
      link_id: value?.link_id ?? "",
      created_start_date: value?.created_start_date ?? "",
      created_end_date: value?.created_end_date ?? "",
      property: value?.property?.id === null ? { id: "", name: "" } : value.property,
      buyer_id: value?.buyer_id ?? "",
    };

    if (from === "lead") {
      dataToSet.lead_source = value?.lead_source ?? "";
      dataToSet.last_contact = value?.last_contact ?? "date";
      dataToSet.lastContactSentDate = value?.lastContactSentDate ?? "";
      dataToSet.lastContactSentSdate = value?.lastContactSentSdate ?? "";
      dataToSet.lastContactSentEdate = value?.lastContactSentEdate ?? "";
      dataToSet.within_last_day = value?.within_last_day ?? "";
      dataToSet.longer_than_day = value?.longer_than_day ?? "";
      dataToSet.date_category = value?.date_category ?? "days";
    }

    if (from === "proposal") {
      dataToSet.status = value?.status === null || value?.status === "" ? "" : value?.status === 0 ? "followup" : value?.status === 1 ? "won" : "lost";
    }

    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  return (
    <div>
      <SavedFilterComponent
        from={from}
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={from === "lead" ? leadSaveSearchFilterData : proposalSaveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={from === "lead" ? initialLeadFilterData : initialProposalFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        from={from}
        desc={`Enter ${from} information.`}
        onFilter={handleFilter}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        saveSearchFilterData={from === "lead" ? leadSaveSearchFilterData : proposalSaveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <LeadsFilterData from={from} isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} />
      </RightModal>
    </div>
  );
};

export default LeadsFilter;